<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户活跃度导出</span>
      </div>
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <!-- 用户类型Tab -->
          <el-form-item>
            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
              <el-tab-pane label="客户加盟商" name="2"></el-tab-pane>
              <el-tab-pane label="业务" name="3"></el-tab-pane>
              <el-tab-pane label="技术" name="4"></el-tab-pane>
              <el-tab-pane label="内部员工" name="1"></el-tab-pane>
            </el-tabs>
          </el-form-item>
          
          <!-- 客户加盟商身份选择 -->
          <el-form-item v-if="activeTab === '2'" label="身份：">
            <el-select v-model="query.customerLevelId" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="研修班" :value="6"></el-option>
              <el-option label="体验版" :value="7"></el-option>
              <el-option label="普通用户" :value="8"></el-option>
            </el-select>
          </el-form-item>
          <!-- 业务身份选择 -->
          <el-form-item v-if="activeTab === '3'" label="身份：">
            <el-select v-model="query.customerLevelId" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="营销总监" :value="1"></el-option>
              <el-option label="营销经理" :value="2"></el-option>
              <el-option label="大区经理" :value="3"></el-option>
              <el-option label="地区经理" :value="4"></el-option>
              <el-option label="县区经理" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <!-- 技术身份选择 -->
          <el-form-item v-if="activeTab === '4'" label="身份：">
            <el-select v-model="query.tehlevelId" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="教育总监" :value="1"></el-option>
              <el-option label="督导" :value="2"></el-option>
              <el-option label="技术老师" :value="3"></el-option>
              <el-option label="带教老师" :value="4"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="手机号：">
            <el-input v-model="query.pho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          
          <!-- 是否是大客户 - 只在客户加盟商tab下显示 -->
          <el-form-item v-if="activeTab === '2'" label="是否是大客户：">
            <el-select v-model="query.isBig" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="区域：" v-if="activeTab != '1'">
            <el-cascader
              v-model="addressValue"
              :options="addressOptions"
              :props="cascaderProps"
              placeholder="请选择区域（建议选择到区级）"
              clearable
              size="small"
              @change="handleAddressChange"
              @visible-change="handleCascaderVisibleChange"
              style="width: 250px;"
            ></el-cascader>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleExport" size="mini" :loading="exportLoading">导出</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'

export default {
  name: 'UserActivityExport',
  data() {
    return {
      exportLoading: false,
      activeTab: '2', // 默认选择客户加盟商
      query: {
        addrAreaCode: '',
        addrCityCode: '',
        addrProvinceCode: '',
        customerLevelId: 0,
        isBig: false,
        pageNo: 0,
        pageSize: 0,
        pho: '',
        tehlevelId: 0,
        userType: 2
      },
      // 区域级联选择器相关数据
      addressValue: [], // 级联选择器的值
      addressOptions: [], // 区域选项数据
      cascaderProps: {
        value: 'regionCode',
        label: 'regionName',
        children: 'child',
        checkStrictly: false, // 必须选择到叶子节点，自动选中父级
        emitPath: true // 返回完整路径
      }
    }
  },
  created() {
    this.loadAddressData()
  },
  methods: {
    /**
     * 清理区域数据，移除空的子级
     */
    cleanAddressData(data) {
      if (!data || !Array.isArray(data)) return data
      
      return data.map(item => {
        const cleanedItem = { ...item }
        if (cleanedItem.child && Array.isArray(cleanedItem.child)) {
          // 递归清理子级数据
          cleanedItem.child = this.cleanAddressData(cleanedItem.child)
          // 如果子级为空数组，则移除child属性
          if (cleanedItem.child.length === 0) {
            delete cleanedItem.child
          }
        }
        return cleanedItem
      }).filter(item => {
        // 过滤掉没有有效数据的项
        return item && item.regionCode && item.regionName
      })
    },
    /**
     * 加载区域数据
     */
    loadAddressData() {
      liveManageApi.getAddressTreeList()
        .then(response => {
          console.log('区域数据接口响应:', response)
          if (response.code === '0' && response.data) {
            // 清理数据，移除空的子级
            this.addressOptions = this.cleanAddressData(response.data)
            console.log('原始区域数据:', response.data)
            console.log('清理后区域数据:', this.addressOptions)
            console.log('区域数据加载成功')
          } else {
            console.error('区域数据加载失败:', response.message)
            this.$message.error('加载区域数据失败: ' + response.message)
          }
        })
        .catch(error => {
          console.error('加载区域数据失败:', error)
          this.$message.error('加载区域数据失败')
        })
    },
    /**
     * 级联选择器可见性变化处理
     */
    handleCascaderVisibleChange(visible) {
      console.log('级联选择器可见性变化:', visible)
      if (visible) {
        console.log('当前区域选项数据:', this.addressOptions)
      }
    },
    /**
     * 区域级联选择器变化处理
     */
    handleAddressChange(value) {
      console.log('区域选择变化:', value)
      if (value && value.length > 0) {
        // 确保选择到区级时，前面的省市也要设置
        this.query.addrProvinceCode = value[0] || ''
        this.query.addrCityCode = value[1] || ''
        this.query.addrAreaCode = value[2] || ''
        
        console.log('设置的完整地址参数:', {
          addrProvinceCode: this.query.addrProvinceCode,
          addrCityCode: this.query.addrCityCode,
          addrAreaCode: this.query.addrAreaCode,
          selectedPath: value
        })
        
        // 如果选择了区级，确保前面的省市也被选中
        if (value.length === 3) {
          console.log('已选择到区级，省市参数已自动设置')
        }
      } else {
        // 清空所有地址参数
        this.query.addrProvinceCode = ''
        this.query.addrCityCode = ''
        this.query.addrAreaCode = ''
        console.log('清空地址参数')
      }
    },
    /**
     * Tab切换处理
     */
    handleTabClick(tab) {
      this.query.userType = parseInt(tab.name)
      // 清空其他等级参数
      this.query.customerLevelId = 0
      this.query.tehlevelId = 0
      // 如果不是客户加盟商，清空是否是大客户参数
      if (tab.name !== '2') {
        this.query.isBig = false
      }
      // 清空区域选择器数据
      this.addressValue = []
      this.query.addrProvinceCode = ''
      this.query.addrCityCode = ''
      this.query.addrAreaCode = ''
    },
    /**
     * 重置表单
     */
    handleFilter() {
      this.query = {
        addrAreaCode: '',
        addrCityCode: '',
        addrProvinceCode: '',
        customerLevelId: 0,
        isBig: false,
        pageNo: 0,
        pageSize: 0,
        pho: '',
        tehlevelId: 0,
        userType: 2
      }
      this.activeTab = '2' // 重置tab为默认选择
      this.addressValue = [] // 重置区域选择器
    },
    /**
     * 导出数据
     */
    handleExport() {
      this.exportLoading = true
      
      // 准备导出参数，只传递有值的参数
      const exportParams = {}
      
      // 只添加有值的参数
      if (this.query.addrAreaCode) {
        exportParams.addrAreaCode = this.query.addrAreaCode
      }
      if (this.query.addrCityCode) {
        exportParams.addrCityCode = this.query.addrCityCode
      }
      if (this.query.addrProvinceCode) {
        exportParams.addrProvinceCode = this.query.addrProvinceCode
      }
      if (this.query.customerLevelId !== undefined && this.query.customerLevelId !== null) {
        exportParams.customerLevelId = this.query.customerLevelId
      }
      if (this.query.isBig !== undefined && this.query.isBig !== null) {
        exportParams.isBig = this.query.isBig
      }
      if (this.query.pho && this.query.pho.trim()) {
        exportParams.pho = this.query.pho.trim()
      }
      if (this.query.tehlevelId !== undefined && this.query.tehlevelId !== null) {
        exportParams.tehlevelId = this.query.tehlevelId
      }
      if (this.query.userType !== undefined && this.query.userType !== null) {
        exportParams.userType = this.query.userType
      }
      
      console.log('导出参数:', exportParams)
      
      liveManageApi.downloadStatisticsByUser(exportParams)
        .then(response => {
          console.log('导出响应:', response)
          if (response.data && response.data.downloadLink) {
            // 创建下载链接
            const link = document.createElement('a')
            link.href = response.data.downloadLink
            link.download = '用户活跃度数据.xlsx'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.$message.success('导出成功，文件开始下载')
          } else {
            this.$message.error('导出失败：未获取到下载链接')
          }
        })
        .catch(error => {
          console.error('导出失败:', error)
          this.$message.error('导出失败：' + (error.message || '未知错误'))
        })
        .finally(() => {
          this.exportLoading = false
        })
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding: 20px;
}
</style>
